import React from 'react';
import Header from './components/Header';
import Routes from './routes';


import './style.css';



const App = () => {
  return(
    <>
    <Header />
    <Routes/>
    </>
  )

}

export default App;
